import { Box, Text } from '@gazin/ecommerce-ui'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'
import Breadcrumbs from 'src/components/breadcrumbs'
import Layout from '../../layouts/padrao'
import {
  BannerCategoryResponse,
  CategoryReponse,
  ChildCategoryResponse,
} from 'src/services/marketplace-api/dtos'
import { getBannerCategory, getCategories } from 'src/services/marketplace-api'
import SearchAndCategoryPage from 'src/templates/SearchAndCategory'
import {
  AutoCompletesLinxResponse,
  SearchProductsResponse,
} from 'src/services/linx-api/dtos'
import { searchProductsCategoryLinx } from 'src/services/linx-api/searchCategory'
import { CategoryCarousel } from 'src/components/categoryCarousel'
import { DefaultCarousel } from 'src/components/carrosselPrincipal/sliderDefault'
import { useBlackFriday } from 'src/contexto/hooks/useBlackFriday'
import { ProductsSortingKey } from 'src/util/enums/products-sorting-key'

type CategoryPageProps = {
  bannersCategory?: BannerCategoryResponse
  conteudoProdutos: SearchProductsResponse
  resultadosAutoComplete: AutoCompletesLinxResponse
}

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const queryCategory =
    query.categoria && query.categoria[0] ? query.categoria[0] : ''
  const page = Number(query.pagina) || 1
  const filter = query.filtro ? query.filtro : null
  const order = query.order ? String(query.order) : ProductsSortingKey.Relevance

  let queryFiltro = ''

  if (filter && !Array.isArray(filter)) {
    queryFiltro = `&filter=${filter}`
  }

  if (filter && Array.isArray(filter) && filter.length > 0) {
    filter.map((filtroSelecionado, key) => {
      queryFiltro = `${queryFiltro}filter=${filtroSelecionado}`
      if (filter.length > 1 && key < filter.length - 1)
        queryFiltro = `${queryFiltro}&`
    })
  }

  const [bannersCategory, conteudoProdutos] = await Promise.all([
    getBannerCategory(queryCategory),
    searchProductsCategoryLinx({
      search: queryCategory,
      filter: queryFiltro,
      order,
      page,
    }),
  ])

  return {
    props: {
      bannersCategory,
      conteudoProdutos: conteudoProdutos ?? null,
    },
  }
}

export default function Departamentos({
  bannersCategory,
  conteudoProdutos,
}: CategoryPageProps) {
  const { isBlackFridayTheme } = useBlackFriday()
  const route = useRouter()

  const [categoria, setCategoria] = useState<CategoryReponse>()
  const [description, setDescription] = useState('')
  const [loadingApi, setLoadingApi] = useState(false)
  const [title, setTitle] = useState('')

  const setInformacoesCategoria = (
    title?: string | null,
    description?: string | null,
    categoria?: string
  ) => {
    const treatedTitle = categoria ? `${categoria} - Gazin.` : 'Gazin'

    setTitle(title || treatedTitle)
    setDescription(
      description
        ? description
        : `As melhores ofertas de ${categoria} você encontra aqui na Gazin!`
    )
  }

  const buscarCategories = useCallback(async () => {
    const treatedCategory =
      route.query.categoria?.[0]
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') || ''

    if (categoria?.slug !== treatedCategory) setLoadingApi(true)

    const data = await getCategories(treatedCategory)
    setCategoria(data)
    setInformacoesCategoria(data?.titulo_seo, data?.descricao_seo, data?.nome)
  }, [categoria?.slug, route.query.categoria])

  const mapCategoryDataForCarousel = (categories: ChildCategoryResponse[]) => {
    if (categories.length < 3) return []

    return categories.map((category) => ({
      value: category.slug,
      description: category.nome,
      media: {
        desktop: category?.desktop_image_url,
        mobile: category?.mobile_image_url,
      },
    }))
  }

  const subCategoriesData = mapCategoryDataForCarousel(
    categoria?.categoria_filhos ?? []
  )

  useEffect(() => {
    buscarCategories().finally(() => setLoadingApi(false))
  }, [buscarCategories, route.query.categoria])

  return (
    <Layout title={title} description={description} pageTopButton>
      <Box as="main" bgColor={{ base: '#f4f4f7', lg: '#ffffff' }}>
        <Breadcrumbs category={categoria} loading={loadingApi} social />
        {!loadingApi && (
          <>
            <Box
              width="100%"
              maxWidth="81.875rem"
              marginX="auto"
              paddingX="0.9375rem"
            >
              <Box width="100%" marginTop="1rem">
                <Text
                  as="h1"
                  fontWeight={600}
                  marginBottom={0}
                  color="#363843"
                  fontSize={{ base: '1.125rem', md: '1.75rem' }}
                >
                  {categoria?.nome}
                </Text>
              </Box>
            </Box>

            {!!bannersCategory?.data?.length && (
              <Box marginTop={{ base: '0', lg: '1.5rem' }}>
                <DefaultCarousel
                  banners={bannersCategory.data}
                  darkTheme={isBlackFridayTheme}
                  isCategory
                />
              </Box>
            )}

            {!!subCategoriesData.length && (
              <Box mx="auto" maxW="81.875rem" p="0 0.9375rem" w="full">
                <CategoryCarousel
                  categories={subCategoriesData}
                  textColor="primary.500"
                  backgroundColor="primary.100"
                  pagination
                />
              </Box>
            )}
          </>
        )}

        <SearchAndCategoryPage
          categorySlug={categoria?.slug}
          category={categoria}
          isCategoryPage
          loadingApi={loadingApi}
          results={conteudoProdutos}
        />
      </Box>
    </Layout>
  )
}
